<template>
  <div class="carousel">
    <v-dialog
      :width="this.$vuetify.breakpoint.xsOnly ? '250' : '500'"
      :disabled="images.length === 0"
    >
      <v-btn
        fab
        small
        slot="activator"
        @click="loadImages"
        class="mx-2"
        :disabled="images.length === 0"
        color="blue-grey darken-1"
      >
        <v-icon>photo</v-icon>
      </v-btn>

      <v-carousel
        class="carousel"
        v-if="startToLoad"
        :hide-delimiters="true"
        :hide-controls="images.length === 1"
        interval="4000"
        :height="getHeight"
      >
        <v-carousel-item
          v-for="(image, i) in images"
          :key="i"
          :src="`${posterPrefix}${image.file_path}`"
        ></v-carousel-item>
      </v-carousel>
    </v-dialog>
  </div>
</template>

<script>
import { base } from "../config/config";

export default {
  props: {
    images: {
      type: Array
    }
  },
  data() {
    return {
      // posterPrefix: base.posterPrefix,
      posterPrefix: base.posterPrefix,
      startToLoad: false
    };
  },
  methods: {
    loadImages() {
      this.startToLoad = true;
    }
  },
  computed: {
    getHeight() {
      switch (this.$vuetify.breakpoint.name) {
        case "xs":
          return "400";
        case "sm":
          return "800";
        case "md":
          return "800";
        case "lg":
          return "700";
        case "xl":
          return "700";
      }
    }
  }
};
</script>
<style lang="scss" scoped>
</style>

